import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
      locale: "",
      locales: ['fr', 'en', 'es', 'it']
  },
});


// WEBPACK FOOTER //
// ./src/vuex/index.ts